export default __webpack_public_path__ + "static/Big-Data-Analytics-48926e6609912cb4aee473c63378b9f8.webp";